import { Gauge, BadgeDollarSign, FileText, ShieldCheck, MapPin } from "lucide-react";
import { useLang } from "@/lib/i18n";

const items = [
  { icon: Gauge, title: "Fast Response Times" },
  { icon: BadgeDollarSign, title: "Honest Pricing" },
  { icon: FileText, title: "Free Estimates" },
  { icon: ShieldCheck, title: "Licensed & Insured" },
  { icon: MapPin, title: "Local HVAC Experts" },
];

export default function WhyChoose() {
  const { t } = useLang();
  return (
    <section className="py-12 md:py-16" data-testid="why-choose">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-2xl">
          <div className="text-xs font-bold uppercase tracking-[0.22em] text-ice-400">Why AIR-COLD</div>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-black">{t("why.title")}</h2>
        </div>
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {items.map(({ icon: Icon, title }, i) => (
            <div key={i} className="card-ink rounded-2xl p-5 text-center" data-testid={`why-card-${i}`}>
              <div className="size-11 mx-auto rounded-xl bg-ice-400/15 ring-1 ring-ice-400/30 grid place-items-center">
                <Icon className="size-5 text-ice-400" />
              </div>
              <div className="mt-3 font-display font-semibold text-sm md:text-base leading-snug">{title}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
